import { useFeatureFlag } from "providers/LaunchDarkly";
import { useJobsSubscription } from "./useJobsSubscription";

/**
 * Whether the web offers to create working interviews at a location: the LD flag, plus the server's verdict
 * (`can_post_working_interviews` is false in a market that can't take shifts). Until the plan loads, the flag decides.
 */
export const useCanPostWorkingInterviews = (locationId?: number): boolean => {
  const flagOn = useFeatureFlag("hire-working-interview-shifts");
  const subscription = useJobsSubscription(locationId);
  return flagOn && subscription?.can_post_working_interviews !== false;
};
